module.exports = __webpack_public_path__ + "img/home_01.6e881a9b.png";